<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-with-heading" id="dedication">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">TO THREE LITTLE KATHARINES</h1>
</div>
</div>
</div>
</div>
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>Oh, Katharines three,</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>Come sail with me</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>Where the ship of my Fancy flies!</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>We’ll wander free</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>Over land and sea,</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>Then sail away to the skies.</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>If I were a star,</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>So far—so far—</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>From this Earth where the children dwell,</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>My twinkliest beam</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>For that ship should gleam;</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>And my truest secret I’d tell</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>To the eyes that look</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>Through fancy.—No book</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>Nor telescope serves so well.</i></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// to-three-little-katharines.vue?164be5ec